// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Algeria */
const DZ = /^(?:5(?:4[0-29]|6[0-4])\d{6}|(?:55|6\d|7[7-9])\d{7})$/;

export default DZ;
